export default "__VITE_ASSET__B$Nmgs0V__"